__turbopack_context__.v({
  "bottomNote": "lnOV-W_bottomNote",
  "bottomNoteBar": "lnOV-W_bottomNoteBar",
  "content": "lnOV-W_content",
  "heroBuyNowButton": "lnOV-W_heroBuyNowButton",
  "overlay": "lnOV-W_overlay",
  "placeholder": "lnOV-W_placeholder",
  "section": "lnOV-W_section",
  "separator": "lnOV-W_separator",
  "stack": "lnOV-W_stack",
  "title": "lnOV-W_title",
  "visual": "lnOV-W_visual",
});
